<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ROUTE_META, TAB_ROUTES } from '@/constants'

const route = useRoute()
const router = useRouter()

const tabs = TAB_ROUTES

const visible = computed(() => Boolean(route.meta[ROUTE_META.tab]))
const active = computed({
  get: () => route.path,
  set: (path: string) => {
    void router.replace(path)
  },
})
</script>

<template>
  <van-tabbar v-if="visible" v-model="active" fixed safe-area-inset-bottom route class="app-tabbar">
    <van-tabbar-item v-for="tab in tabs" :key="tab.path" :name="tab.path" :to="tab.path" :icon="tab.icon">
      {{ tab.label }}
    </van-tabbar-item>
  </van-tabbar>
</template>

<style scoped>
.app-tabbar {
  border-top: 1px solid var(--theme-border);
  background: rgba(var(--theme-background-rgb), 0.94);
  box-shadow: none;
}

.app-tabbar :deep(.van-tabbar-item__icon) {
  margin-bottom: 4px;
  font-size: 22px;
}

.app-tabbar :deep(.van-tabbar-item) {
  color: var(--theme-text-tertiary);
  transition: color 0.2s ease;
}

.app-tabbar :deep(.van-tabbar-item--active) {
  color: var(--theme-primary);
}

.app-tabbar :deep(.van-tabbar-item--active .van-tabbar-item__icon) {
  color: var(--theme-primary);
}
</style>
